import { routeHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CookiePolicy from "@/pages/CookiePolicy";

export const Route = createFileRoute("/by/cookie-policy")({
  head: () => routeHead('Палітыка cookies — AGAPE', 'Даведайцеся, як AGAPE выкарыстоўвае cookies і налады прыватнасці.', '/by/cookie-policy'),
  component: CookiePolicy,
});
